<template>
    <div>
        <template v-if="action=='view'">
        <div class="table-settings mb-4" v-if="allData.total>0 || q!=''">
            <div class="row align-items-center justify-content-between">
                <div class="col col-md-6 col-lg-3 col-xl-4">
                    <!-- <div class="input-group">
                        <span class="input-group-text" id="basic-addon2"><span class="fas fa-search"></span></span>
                        <input v-model="q" type="search" class="form-control" id="exampleInputIconLeft" placeholder="Search" aria-label="Search" aria-describedby="basic-addon2">
                    </div> -->
                </div>
                <div class="col-4 col-md-2 col-xl-1 pl-md-0 text-right">

                </div>
            </div>
        </div>
        <div class="card border-light shadow-sm mb-4">
        <div class="card-body" v-if="loading==false && (allData.total>0 || q!='')">
            <table class="table table-hover">
                <thead class="thead-light">
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Image</th>
                        <th>Is Home</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody v-if="allData.total>0">
                    <tr v-for="data in allData.data" :key="data.id">
                        <td>
                            <a href="#" class="font-weight-bold">
                                {{data.id}}
                            </a>
                        </td>
                        <td><span class="font-weight-normal">{{data.heading}}</span></td>
                        <td><span class="font-weight-normal">                             <img v-if="data.image!=''"  :src="$root.URL_ROOT+'uploads/brand/'+data.image" width="50">
</span></td>
                        <td><span class="font-weight-bold">
                            <a class="btn btn-danger btn-xs" href="#" @click="update('mss_brand','is_home',1,[data.id]);data.is_home=1" v-if="data.is_home==0">Inacive</a>
                            <a class="btn btn-success btn-xs" href="#" @click="update('mss_brand','is_home',0,[data.id]);data.is_home=0" v-if="data.is_home==1">Acive</a>
                        </span></td>
                        <td><span class="font-weight-bold">
                            <a class="btn btn-danger btn-xs" href="#" @click="update('mss_brand','status',1,[data.id]);data.status=1" v-if="data.status==0">Inacive</a>
                            <a class="btn btn-success btn-xs" href="#" @click="update('mss_brand','status',0,[data.id]);data.status=0" v-if="data.status==1">Acive</a>
                        </span></td>
                        <td>
                            <a class="btn btn-info btn-xs hide" href="../invoice.html"><span class="fas fa-eye mr-2"></span>View Details</a>
                            <div class="btn-group">
                                <router-link class="btn btn-primary btn-xs" :to="{name : 'index', params: { page: page, action: 'edit', id: data.id }}"><span class="fas fa-edit mr-2"></span>Edit</router-link>
                                <a @click="remove(data.id)" class="btn btn-danger btn-xs" href="#"><span class="fas fa-trash-alt mr-2"></span>Remove</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td class="text-center" colspan="5">No record found</td>
                    </tr>
                </tbody>
            </table>
            <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                <nav aria-label="Page navigation example">
                    <ul class="pagination mb-0">
                        <template v-for="(paginate,key) in allData.links">
                            <li :key="key" class="page-item" :class="{'active': paginate.active}" v-if="paginate.url">
                                <a class="page-link" @click="viewAllUrl=paginate.url;allDatas(false)" v-html="paginate.label"></a>
                            </li>
                        </template>
                    </ul>
                </nav>
                <div class="font-weight-bold small">Page <b>{{allData.current_page}}</b> of <b>{{allData.last_page}}</b> page Total record <b>{{allData.total}}</b></div>
            </div>
        </div>
        <div class="card-body text-center" v-else>
            <div v-if="loading">
                loading...
            </div>
            <div v-else>
                <InlineSvg name="nouser"></InlineSvg>
                <div>
                    <h3>Add and manage your {{page}}</h3>
                    <p>This is where you’ll add {{page}} and manage theme. You can also improve your website by adding.</p>
                    <router-link :to="{name : 'index', params: { page: page, action: 'add' }}" class="btn btn-primary" type="button">Add {{page}}</router-link>
                    <br><br><br>
                </div>
            </div>
        </div>
        </div>
        </template>
        <template v-else>
            <div class="row">
                <div class="col-12 col-xl-8">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">General information</h2>
                        <div class="row">
                            <div class="col-md-6 mb-3"> 
                                <MssInput v-model="form.linkname" placeholder="Enter Page Link" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.heading" placeholder="Enter Page Heading" required></MssInput>
                            </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.icon" placeholder="Category Icon" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3"> 
                                <MssInput type="file" v-model="form.image" placeholder="Brand Image" required></MssInput>
                            </div>
                             <div class="col-md-6 mb-3"> 
                            </div> <div class="col-md-6 mb-3"> 
                                <img  :src="$root.URL_ROOT+'uploads/brand/'+form.image" width="50">
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-4 sidebar-stricky">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">Visibility</h2>
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.status" placeholder="Visible this page to all"></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.is_home" placeholder="Visible this page to Home"></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div>
                                    <button @click="submit" class="btn btn-info btn-block" v-if="action=='add'">Publish</button>
                                    <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">Page Position</h2>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.lorder" placeholder="Page order"></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <div>
                                    <label for="lorder">Under of</label>
                                    <MssSelect v-model="form.underof" placeholder="Parent" :reduce="pageList => pageList.code" :options="pageList"></MssSelect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <div class="row">
                            <h2 class="col-md-8 h5 mb-4">SEO information</h2>
                            <div class="col-md-4 text-right">
                                <button @click="defaultSEO=false;editSEO = editSEO ? false : true" class="btn btn-info btn-xs"><span class="far fa-edit mr-2"></span>Edit</button>
                            </div>
                        </div>
                        <!-- <div class="row hide"  v-if="editSEO">
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.meta_title" placeholder="SEO title of this page"></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.meta_keywords" placeholder="keywords for this page"></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <MssInput type="textarea" v-model="form.meta_description" placeholder="Seo Description max 150 char"></MssInput>
                            </div>
                        </div> -->
                        <!-- <div v-else class="row align-items-center">
                            <h3>{{form.meta_title}}</h3>
                            <a href="javascript:;">{{URL_ROOT}}category/{{form.linkname}}</a>
                            <p>{{limitedword(striphtml(form.meta_description),150)}}</p>

                        </div> -->
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import $ from 'jquery'
// import { VueEditor } from "vue2-editor";
export default {
    components: {
        // VueEditor
    },
    props:[
        "page","action","id","type"
    ],
    data() {
        return {
            isEditor: true,
            q:'',
            loading: false,
            allData: [],
            form: {
                id:null,
                lorder:0,
                status: true,
                heading:'',
                image:'',
                icon:'',
                pbody: '',
                underof: 0,
                linkname:''
            },
            editSEO: false,
            defaultSEO: true,
            pageList:[],
            fullToolbar : [
                [{ 'font': [] }],
                [{ 'header': [false, 1, 2, 3, 4, 5, 6, ] }],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{'align': [false,'justify','center','right']}],
                //[{ 'header': 1 }, { 'header': 2 }],
                //['blockquote', 'code-block'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
                //[{ 'script': 'sub'}, { 'script': 'super' }],
                [{ 'indent': '-1'}, { 'indent': '+1' }],
                [{ 'color': [] }, { 'background': [] }],
                ['link', 'image', 'video', 'formula'],
                //[{ 'direction': 'rtl' }],
                ['clean'],
            ],
            viewAllUrl:''
        }
    },
    methods: {
        addInit(){
            this.getUnderof();
        },
        editInit(){
            this.getDetail();
            this.getUnderof();
        },
        viewInit(){
            this.viewAllUrl=this.URL_ROOT+'admin/'+this.page+'/all'
            this.allDatas(true)
        },
        reset(){
            this.form = {
                id:null,
                lorder:0,
                status: true,
                heading:'',
                pbody: '',
                underof: 0,
                linkname:''
            };
        },
        getUnderof(){
            var pList=[];
            pList.push({label: 'Parent', code: 0})
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT+'admin/'+this.page+'/allcategory/?field=heading,id,is_parent',
                "success": (response)=>{
                    if(response.status=="success"){
                        console.log(response.data);
                        $.each(response.data, function(key,param) {
                            //console.log(param,key);
                            pList.push({label: param.heading, code: param.id})
                        })
                    }
                    this.pageList = pList;
                }
            })
            /**
             if(this.action=="add"){
                this.from.lorder = response.length+1;
            } */
        },
        getDetail(){
            this.loading=true
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT+'admin/'+this.page+'/detail/'+this.id,
                "success": (response)=>{
                    this.form = response;
                    this.loading=false
                }
            })
        },
        allDatas(isLoad){
            if(isLoad)this.loading=true
            this.pageList=[];
            $.ajax({
                "method": 'GET',
                "url": this.viewAllUrl,
                "success": (response)=>{
                    this.allData = response;
                    if(isLoad)this.loading=false
                }
            })
        },
        submit(){
            this.loading=true
            $.ajax({
                "method": 'POST',
                "url": this.URL_ROOT+'admin/'+this.page+'/submit',
                "data": this.form,
                "success": (response)=>{
                    this.loading = false 
                    if(response.status=="success"){
                     setTimeout(() =>   this.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                            icon: 'success',
                            timerProgressBar: true,
                            title: 'Action perform successfully'
                        }), 1000);
                        this.$router.push({name : 'index', params: { page: this.page, action: 'edit', id: response.data.id }})
                    }else{
                        var message = ""
                        $.each(response.data,function(key,val){
                            message += val+"\n";
                        })
                        setTimeout(() => this.$swal('Error Please check',message,"error"), 1000);
                       // this.$swal('Error Please check',message,"error")
                    }

                }
            })
        },
        remove(id){
            var self =this;
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if(result.isConfirmed){
                    $.ajax({
                        "method": 'DELETE',
                        "url": this.URL_ROOT+'admin/'+this.page+'/remove/'+id,
                        "success": (response)=>{
                            console.log(response)
                            self.allDatas(true)
                            self.$swal('Delete successfullly',"selected record has been deleted successfully","success")
                        }
                    })
                }
            })
        }
    },
    mounted(){
        if(this.action=="view"){
            this.viewInit()
        }else if(this.action=="edit" && this.id>0){
            this.editInit()
        }else if(this.action=="add"){
            this.addInit();
        }
    },
    watch: {
        'action': function(val) {
            if(val=="view"){
                this.viewInit()
            }else if(val=="edit" && this.id>0){
                this.editInit()
            }else if(val=="add"){
                this.addInit();
            }
        },'form.linkname': function(val) {
            var text = val.replace(' ', "")
            this.form.linkname = text
        },
        'loading': function(val) {
            if(val){
                this.$swal.showLoading();
            }else{
                this.$swal.close()
            }
        },'q': function(newVal,oldVal) {
            if(newVal==''){
                this.viewAllUrl = this.URL_ROOT+'admin/'+this.page+'/all';
            }else if(newVal!=oldVal){
                this.viewAllUrl = this.URL_ROOT+'admin/'+this.page+'/all/'+newVal;
            }
            this.allDatas(false);
        }
    }
}
</script>
<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";
</style>
